import { FloatElement } from '../../components/float-element/float-element'

export class HotspotsFloatElement extends FloatElement {
  mountComponent(): void {
    super.mountComponent()
    this.mount()
  }

  unmount(): void {}
}
